import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import HandymanIcon from '@mui/icons-material/Handyman';
import './Forms.css';

const RegisterChoice = () => {
  const navigate = useNavigate();

  return (
    <div className="form-page">
      <div className="form-wrap">
        <div className="form-card">
          <div className="form-head">
            <h1>Crear cuenta</h1>
            <p>¿Cómo quieres usar Cuadrilla Maestra?</p>
          </div>

          <div className="choice-grid">
            <button
              type="button"
              className="choice-card"
              onClick={() => navigate('/registro/cliente')}
            >
              <PersonIcon sx={{ fontSize: 40 }} />
              <span className="choice-title">Soy cliente</span>
              <span className="choice-desc">Quiero contactar maestros y publicar mis necesidades.</span>
            </button>

            <button
              type="button"
              className="choice-card"
              onClick={() => navigate('/registro/trabajador')}
            >
              <HandymanIcon sx={{ fontSize: 40 }} />
              <span className="choice-title">Soy trabajador</span>
              <span className="choice-desc">Soy obrero o maestro de obra y quiero conseguir clientes.</span>
            </button>
          </div>

          <div className="form-foot">
            ¿Ya tienes cuenta? <Link to="/login">Ingresa</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterChoice;
